import React from "react";
import { useClientSideSplitTreatments } from "@leafly-com/split-next";
import Link from "next/link";

import { MenuItem } from "custom-types/MenuItem";
import { MenuItemV2 } from "custom-types/MenuItemV2";
import { VariantWithDeliveryInfo } from "custom-types/Variant";
import { isInValidationGroup } from "utils/dispensaryUtils";
import { getMenuItemUrl } from "utils/menuItemUrl";
import { getSplitKey } from "utils/split/getSplitKey";

import Button from "components/botanic/Button";

import { AddToBagButton } from "./AddToBagButton";

type MenuItemCardActionsProps = {
  menuItem: MenuItem | MenuItemV2 | VariantWithDeliveryInfo;
  onClick?: () => void;
  viewDetailsOnClick?: () => void;
  onMenuItemReserved?: () => void;
  splitClickEventName?: string;
  splitPageProperty?: string;
  merchandisingCampaignId?: number;
};

export const MenuItemCardActions: React.FC<MenuItemCardActionsProps> = ({
  menuItem,
  onClick = () => {},
  viewDetailsOnClick = () => {},
  onMenuItemReserved = () => {},
  splitClickEventName,
  splitPageProperty,
  merchandisingCampaignId,
}) => {
  const menuItemUrl = getMenuItemUrl(menuItem, menuItem.id);

  const { treatments, isLoading } = useClientSideSplitTreatments(
    "shopEveryMenuMVP_test",
    getSplitKey()
  );
  const shopEveryMenuMVPEnabled =
    !isLoading && treatments.shopEveryMenuMVP_test.treatment === "on";
  const isInShopEveryMenuTest =
    isInValidationGroup(menuItem?.dispensary?.id) && shopEveryMenuMVPEnabled;

  return isInShopEveryMenuTest || menuItem.onlineFulfillmentEnabled ? (
    <AddToBagButton
      defaultVariantId={menuItem.id}
      menuItem={menuItem}
      onClick={onClick}
      onReservation={onMenuItemReserved}
      splitClickEventName={splitClickEventName}
      splitPageProperty={splitPageProperty}
      merchandisingCampaignId={merchandisingCampaignId}
    />
  ) : (
    <Link href={menuItemUrl} passHref legacyBehavior>
      <Button
        variant="tertiary"
        size="small"
        onClick={viewDetailsOnClick}
        style={{ paddingBottom: 6, paddingTop: 6 }}
        href={menuItemUrl}
        data-testid="view-details-button"
      >
        view details
      </Button>
    </Link>
  );
};
